import React, { lazy, Suspense, useEffect } from "react";
import { Spin } from "antd";
import { Switch, Route, useHistory } from "react-router-dom";
import { getUserToken } from "../hooks/authFunctions";
import { useSignOutGeneral } from "../hooks/generalFunction";

const Login = lazy(() =>
  import("../container/profile/authentication/overview/SignIn")
);

function FrontendRoutes() {
  const history = useHistory();

  const signOut = useSignOutGeneral();

  const SignOut = async () => {
    //logout aws session
    signOut();
  };

  useEffect(() => {
    const checkUserSession = async () => {
      try {
        const user = await getUserToken();
        const token = user.accessToken.toString();
        if (token === "") {
          history.push("/");
        }
        // console.log("User is signed in:", token);
        // User session is valid
      } catch (error) {
        //logout user
        SignOut();
        // console.log("User is not signed in:", error);
        history.push("/");
      }
    };

    checkUserSession();
  }, []);

  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }>
        <Route exact path="/" component={Login} />
      </Suspense>
    </Switch>
  );
}

export default FrontendRoutes;
